/**
 * Copy a room's invite link with inline feedback: `copied` is true for two
 * seconds after a successful copy, so the button itself can say "Copied"
 * (the toast from copyRoomLink still covers the failure path).
 */
import { useCallback, useEffect, useRef, useState } from 'react';
import { copyRoomLink } from './share';

export const COPIED_FEEDBACK_MS = 2000;

export function useCopyRoomLink(code: string): { copied: boolean; copy: () => Promise<void> } {
  const [copied, setCopied] = useState(false);
  const timer = useRef<number | undefined>(undefined);

  useEffect(() => () => window.clearTimeout(timer.current), []);

  const copy = useCallback(async () => {
    const ok = await copyRoomLink(code);
    if (!ok) return;
    window.clearTimeout(timer.current);
    setCopied(true);
    timer.current = window.setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS);
  }, [code]);

  return { copied, copy };
}
